import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { appLocale } from 'shared';

import { useSpecialOffersStore } from './use-special-offers-store';

export function useSpecialOffers() {
  const specialOffersStore = useSpecialOffersStore();
  const { origCity } = storeToRefs(specialOffersStore);
  const { locale } = useI18n();

  const origCityCode = computed(() => origCity.value.code);

  const origCityName = computed(() => {
    const city = origCity.value;
    const currentLocale = locale.value;

    switch (currentLocale) {
      case appLocale.config.locales.RU:
        return city.name_ru || city.name;
      case appLocale.config.locales.EN:
        return city.name_en || city.name;
      case appLocale.config.locales.KZ:
        return city.name_kk || city.name;
      default:
        return city.name;
    }
  });

  return {
    origCity,
    origCityCode,
    origCityName,
    changeOrigCity: specialOffersStore.changeOrigCity,
  };
}
